import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqList } from "@/mocks/articles";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.5fr]">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="你可能想知道"
            desc="关于樱花漫画的常见疑问，这里都有答案。如果还有疑问，欢迎随时联系我们。"
          />
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 bg-primary-50 px-6 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看全部问答
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {faqList.slice(0, 4).map((item, i) => {
            const open = openIdx === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  open ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-lg text-primary-600 transition-transform ${
                      open ? "ri-subtract-fill" : "ri-add-fill"
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}